import { z } from 'zod';
import { sectionJConsistency } from '../oasis-rules/consistency/section-j';
export const baseJ1900 = z.object({
    a: z.string().nullish(),
    b: z.string().nullish(),
    c: z.string().nullish(),
});
export const processedM1033 = z.preprocess((input, ctx) => {
    sectionJConsistency({ input, ctx, field: 'm1033' });
    return input;
}, z.array(z.string()));
export const SectionJ = {
    m1033: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'ofu', 'rct'],
    },
    j0510: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    j0520: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    j0530: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    j1800: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dth', 'dsch'],
    },
    j1900: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dth', 'dsch'],
        fields: {
            a: {
                version: ['e1'],
                timepoint: ['tr', 'trd', 'dth', 'dsch'],
            },
            b: {
                version: ['e1'],
                timepoint: ['tr', 'trd', 'dth', 'dsch'],
            },
            c: {
                version: ['e1'],
                timepoint: ['tr', 'trd', 'dth', 'dsch'],
            },
        },
    },
    m1400: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
};
// J-J0510-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Does not apply - I have not had any pain or hurting in the past 5 days"},{"value":"1","label":"Rarely or not at all"},{"value":"2","label":"Occasionally"},{"value":"3","label":"Frequently"},{"value":"4","label":"Almost Constantly"},{"value":"8","label":"Unable to answer"}]
// J-J0520-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Does not apply - I have not received rehabilitation therapy in the past 5 days"},{"value":"1","label":"Rarely or not at all"},{"value":"2","label":"Occasionally"},{"value":"3","label":"Frequently"},{"value":"4","label":"Almost Constantly"},{"value":"8","label":"Unable to answer"},{"value":"^","label":"Blank (skip pattern)"}]
// J-J0530-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"1","label":"Rarely or not at all"},{"value":"2","label":"Occasionally"},{"value":"3","label":"Frequently"},{"value":"4","label":"Almost constantly"},{"value":"8","label":"Unable to answer"},{"value":"^","label":"Blank (skip pattern)"}]
// J-J1800-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"No"},{"value":"1","label":"Yes"},{"value":"-","label":"Not assessed/no information"}]
// J-J1900A-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"None"},{"value":"1","label":"One"},{"value":"2","label":"Two or more"},{"value":"-","label":"Not assessed/no information"},{"value":"^","label":"Blank (skip pattern)"}]
// J-J1900B-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"None"},{"value":"1","label":"One"},{"value":"2","label":"Two or more"},{"value":"-","label":"Not assessed/no information"},{"value":"^","label":"Blank (skip pattern)"}]
// J-J1900C-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"None"},{"value":"1","label":"One"},{"value":"2","label":"Two or more"},{"value":"-","label":"Not assessed/no information"},{"value":"^","label":"Blank (skip pattern)"}]
// J-M1033_HOSP_RISK_COMPLIANCE-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_HSTRY_FALLS-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_MLTPL_ED_VISIT-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_5PLUS_MDCTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_CRNT_EXHSTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_MLTPL_HOSPZTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_MNTL_BHV_DCLN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_NONE_ABOVE-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_OTHR_RISK-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1033_HOSP_RISK_WEIGHT_LOSS-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// J-M1400_WHEN_DYSPNEIC-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Patient is not short of breath"},{"value":"01","label":"When walking more than 20 feet, climbing stairs"},{"value":"02","label":"With moderate exertion (for example, while dressing, using commode or bedpan, walking distances less than 20 feet)"},{"value":"03","label":"With minimal exertion (for example, while eating, talking, or performing other ADLs) or with agitation"},{"value":"04","label":"At rest (during day or night)"}]
